export const MEETING_TYPE = {
  SUMMIT: 1,
  ROADSHOW: 2,
  ONLINE: 3,
  OFFLINE: 4,
}
